import { useQuery } from '@tanstack/react-query';
import { customInstance } from '@/common/infrastructure/http/apiClient';
import { mapPreviewContextDto, type PreviewContextApiDto } from '@/document-types/application/mappers/mapPreviewContextDto';
import type { DocumentContext } from '@/document-render/domain/DocumentContext';
import type { DocumentTypeRef } from '@/document-types/domain/types/DocumentType';

export const samplePreviewContextQueryKey = (ref: DocumentTypeRef | undefined) =>
  ['document-builder', 'preview-context-sample', ref?.applicationKey, ref?.moduleKey, ref?.documentTypeKey] as const;

export const useSamplePreviewContext = (ref?: DocumentTypeRef) => {
  const enabled = !!ref?.applicationKey && !!ref?.moduleKey && !!ref?.documentTypeKey;

  return useQuery({
    queryKey: samplePreviewContextQueryKey(ref),
    enabled,
    queryFn: async (): Promise<DocumentContext> => {
      if (!ref) throw new Error('DocumentTypeRef is required');

      const url = `/api/pdf-templates/v1/document-types/by-keys/${ref.applicationKey}/${ref.moduleKey}/${ref.documentTypeKey}/preview-context/sample`;
      const raw = await customInstance<PreviewContextApiDto>({ url, method: 'GET' });
      return mapPreviewContextDto(raw);
    },
    staleTime: 1000 * 60 * 10
  });
};
